"use strict";

exports.__esModule = true;
exports.FlexRowElement = FlexRowElement;
var _react = _interopRequireDefault(require("react"));
var _getNonWidgetProps = require("../../ConfigurableLayout/common/getNonWidgetProps");
var _Box = require("../../Core/Box");
var _FlexRow = require("../../Core/FlexGrid/FlexRow");
var _DeviceColorSources = require("../../Device/DeviceColorSources");
var _excluded = ["children"],
  _excluded2 = ["x", "y", "width", "height", "gutter", "children", "render", "backgroundColor", "backgroundColorSource"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CloneBox = function CloneBox(_ref) {
  var children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Box.Box, extra, function (size) {
    return /*#__PURE__*/_react["default"].cloneElement(children, size);
  });
};

/**
 * Displays a flexbox-like row.
 */
function FlexRowElement(_ref2) {
  var _ref2$x = _ref2.x,
    x = _ref2$x === void 0 ? 0 : _ref2$x,
    _ref2$y = _ref2.y,
    y = _ref2$y === void 0 ? 0 : _ref2$y,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 128 : _ref2$width,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? 128 : _ref2$height,
    _ref2$gutter = _ref2.gutter,
    gutter = _ref2$gutter === void 0 ? 0 : _ref2$gutter,
    children = _ref2.children,
    render = _ref2.render,
    backgroundColor = _ref2.backgroundColor,
    backgroundColorSource = _ref2.backgroundColorSource,
    extra = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  var body = children.length > 0 ? render(children) : /*#__PURE__*/_react["default"].createElement("div", null);
  var row = /*#__PURE__*/_react["default"].createElement(_FlexRow.FlexRow, _extends({
    rowComponent: _Box.Box,
    cellComponent: CloneBox,
    x: x,
    y: y,
    width: width,
    height: height,
    gutter: gutter
  }, (0, _getNonWidgetProps.getNonWidgetProps)(extra)), body);
  if (backgroundColorSource || backgroundColor) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DeviceColorSources.DeviceColorBox, {
      x: x,
      y: y,
      width: width,
      height: height,
      backgroundColor: backgroundColor,
      backgroundColorSource: backgroundColorSource
    }), row);
  }
  return row;
}